import { useAuth } from "@/context/AuthContext";

const native = (code) => {
  try { return new Intl.DisplayNames([code], { type: "language" }).of(code); } catch { return ""; }
};

export const useLanguages = (withAuto = false) => {
  const { config } = useAuth();
  const list = (config?.languages || []).map((l) => {
    const n = l.site !== "en" ? native(l.site) : "";
    return { ...l, alt: n, label: n && n.toLowerCase() !== l.name.toLowerCase() ? `${l.name} · ${n}` : l.name };
  });
  return withAuto ? [{ id: "auto", name: "Auto-match", label: "Auto-match · mirror their language", site: "en" }, ...list] : list;
};
